module.exports = __webpack_public_path__ + "static/user-02-fe9922754dfbd15b5dd79e78dd4e0a69.png";